module.exports = __webpack_public_path__ + "static/img/section_bg_mo.38e88f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010103/section_bg_mo.png
// module id = 3Kq7
// module chunks = 10